import React, { useEffect, useState } from "react";
import { carrersData } from "./carrers";
import CarrerCard from "./CarrerCard";
import "./carrer.css";

import {
  MagnifyingGlassIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/24/outline";
import PageTitleCard from "../../templates/PageTitleCard";
import PageTitleHeading from "../../templates/PageTitleHeading";
import PageHeading from "../../../templates/PageHeading";
import { useQuery } from "react-query";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import JobinformationCard from "./templates/JobinformationCard";
import BorderLine from "../../../templates/borderline/BorderLine";
import FixedFooter from "../../templates/FixedFooter";
import Footer from "../../../components/footer/Footer";
import BackHome from "../../../templates/BackHome";
import SubHeadingText from "../../../common/SubHeadingText";
import RightArrow from "../../../templates/RightArrow";
import CurrentPath from "../../../templates/CurrentPath";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const Carrer = () => {
  const [newData, setNewData] = useState([]);
  const { data, isLoading } = useQuery({
    queryKey: "getAllJob",
    queryFn: () =>
      axios.get(`${BASEURL}job`).then((res) => {
        return res?.data;
      }),
  });
  useEffect(() => {
    setNewData(data);
  }, [data]);
  const { data: categoryData } = useQuery({
    queryKey: "getAllCategory",
    queryFn: () =>
      axios.get(`${BASEURL}jobs`).then((res) => {
        return res?.data;
      }),
  });

  const handleChange = async (e) => {
    const value = e.target.value;
    if (value != "") {
      try {
        const res = await axios.get(
          `${BASEURL}jobs?title=${value?.toLowerCase()}`
        );

        setNewData(res?.data?.data);
      } catch (err) {
        setNewData([{ question: "No question" }]);
      }
    } else {
      setNewData(data);
    }
  };

  const handleCategorgyClick = async (value) => {
    if (value != "") {
      try {
        const res = await axios.get(
          `${BASEURL}jobs?category=${value?.toLowerCase()}`
        );

        setNewData(res?.data?.data);
      } catch (err) {
        setNewData([{ question: "No question" }]);
      }
    } else {
      setNewData(data);
    }
  };

  return (
    <div className="">
      <PageTitleCard>
        <PageHeading>Carrers</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Carrers</CurrentPath>
        </div>
      </PageTitleCard>

      <FixedFooter>
        <div className="container  mx-auto md:px-4 sm:px-4 max-sm:px-8 py-8 ">
          <SubHeadingText>Current Openings</SubHeadingText>

          <div className="lg:flex w-full md:block sm:block max-sm:block py-8">
            <div className="relative bg-gray-50 p-4 rounded-lg shadow-lg lg:hidden md:block sm:block max-sm:block ">
              <input
                placeholder="Search Job Postings"
                onChange={(e) => handleChange(e)}
                className="w-full h-12 bg-white rounded-2xl shadow-lg outline-none relative p-4 px-10 pl-20"
              />
              <MagnifyingGlassIcon className="w-5 h-5 absolute top-8 left-8  z-10" />
            </div>
            <div className="carrer-card-parent lg:w-1/2 md:w-full sm:w-full max-sm:w-full">
              {newData?.length == 0 ? (
                <>
                  <div className="my-8 px-10 border bg-red-400 py-4 text-speed-red font-semibold text-lg rounded-lg">
                    No Job Posts Found
                  </div>
                </>
              ) : (
                <>
                  {" "}
                  {isLoading ? (
                    <Skeleton className="py-4 flex items-center border rounded-2xl w-full my-4 carrer-card cursor-pointer h-48" />
                  ) : (
                    newData?.map((v, i) => {
                      return (
                        <CarrerCard
                          key={i}
                          jobtitle={v.title}
                          jobexperince={v.experience}
                          jobtype={v.type}
                          index={i}
                          id={v.id}
                          deadline={v.deadline}
                          location={v.location}
                        />
                      );
                    })
                  )}
                </>
              )}
            </div>
            <div className="lg:w-1/2 md:w-full sm:w-full max-sm:w-full lg:px-16 py-6 relative">
              <div className="relative bg-gray-50 p-4 rounded-lg shadow-lg lg:block md:hidden sm:hidden max-sm:hidden  ">
                <input
                  placeholder="Search Job Postings"
                  onChange={(e) => handleChange(e)}
                  className="w-full h-12 bg-white rounded-2xl shadow-lg outline-none relative p-4 px-10 pl-20"
                />
                <MagnifyingGlassIcon className="w-5 h-5 absolute top-8 left-8  z-10" />
              </div>

              <div className="text-center my-8  rounded-lg bg-gray-50 shadow-lg min-h-40 py-4 ">
                <h2 className="my-4 font-semibold text-2xl">Job Categories</h2>
                <div className="flex items-center lg:px-14 py-2 border-b mx-6 ">
                  {/* <ChevronDoubleRightIcon className="w-6 h-6 mr-5 text-forging-yellow font-extrabold text-lg" /> */}

                  <p
                    onClick={() => setNewData(data)}
                    className="text-lg capitalize cursor-pointer font-semibold text-mute-grey"
                  >
                    All Category
                  </p>
                </div>
                {categoryData?.data?.map((v, i) => (
                  <div
                    key={i}
                    className="flex items-center lg:px-14 py-4 border-b mx-6 "
                  >
                    {/* <ChevronDoubleRightIcon className="w-6 h-6 mr-5 text-forging-yellow font-extrabold text-lg" /> */}

                    <p
                      onClick={() => handleCategorgyClick(v?.category)}
                      className="text-lg capitalize cursor-pointer font-semibold text-mute-grey"
                    >
                      {v?.category}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </FixedFooter>
    </div>
  );
};

export default Carrer;
